<template>
  <v-layout align-center column>
    <p class="Section-Title">See Available Position</p>
    <v-skeleton-loader
      type="image"
      class="Career-Image"
      v-if="!isImgLoaded"
    ></v-skeleton-loader>
    <img
      src="../../assets/TentangKami/Career-Image.png"
      srcset="
        ../../assets/TentangKami/Career-Image@2x.png 2x,
        ../../assets/TentangKami/Career-Image@3x.png 3x
      "
      @load="onImgLoad"
      class="Career-Image"
    />
    <div class="box">
      <p class="Desc">
        Hola, were recruiting good people to fill several position, send ur
        latest <span class="text-style-1">CV and Portfolio </span>to
        <span class="text-style-1">join@dompetkilat.co.id</span>
      </p>
      <p class="Web-Developer" style="cursor: pointer" @click="toRecruitment">
        <img class="Ellipse Point" />Product Owner
      </p>
      <p class="Web-Developer" style="cursor: pointer" @click="toRecruitment">
        <img class="Ellipse Point" />Risk and Compliance Manager
      </p>
      <p class="Web-Developer" style="cursor: pointer" @click="toRecruitment">
        <img class="Ellipse Point" />Data Engineer
      </p>
      <p class="Web-Developer" style="cursor: pointer" @click="toRecruitment">
        <img class="Ellipse Point" />Backend Developer
      </p>
    </div>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      isImgLoaded: false,
    };
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
    toRecruitment() {
      window.location =
        "https://www.linkedin.com/jobs/view/2493131587/?refId=5z0n8buARhC5yrT%2Bf%2F2iuQ%3D%3D";
    },
  },
};
</script>
<style scoped>
.Section-Title {
  width: 328px;
  height: 23px;
  flex-grow: 0;
  margin: 60px 0px 32px 0;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Desc {
  width: 328px;
  height: 60px;
  flex-grow: 0;
  margin: 0 0 12px;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Desc .text-style-1 {
  font-weight: bold;
}
.Career-Image {
  width: 328px;
  height: 218.1px;
  flex-grow: 0;
  margin: 10px 0 15.9px;
  object-fit: contain;
}
.Client-Representative {
  width: 482px;
  height: 22px;
  flex-grow: 0;
  margin: 0 0 0 8px;
  font-family: Sora;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Point {
  width: 494px;
  height: 22px;
  flex-grow: 0;
  margin: 16px 0 8px 20px;
}
.Web-Developer {
  width: 276px;
  height: 21px;
  flex-grow: 0;
  margin: 0 0 0 8px;
  font-family: Sora;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Ellipse {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  margin: auto 8px 4px 0;
  background-color: #252525;
}
.box {
  margin-top: 3%;
}
</style>
